export default () => ({
    token: null,
    myEntity: {},
    isAuthenticated: false,
    blockchainizeState: {},
    isNetworkFailure: false,
    isNotAuthenticated: false
});
